import React, {useEffect, useState} from "react";
import { Grid } from "@material-ui/core";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import BarChart from "./components/BarChart/BarChart";
import PieChart from "./components/PieChart/PieChart";
import DoughnutChart from "./components/DoughnutChart/DoughnutChart";
import LineChart from "./components/LineChart/LineChart";
import {read} from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import HomeService from "Services/http/endpoints/home/HomeService";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

export default function HomePageStatisticsIndex({externalData}) {
  const [loading, setLoading] = useState(false);
  const [dataBar, setDataBar] = useState(null);
  const [dataLine, setDataLine] = useState(null);
  const [dataPie, setDataPie] = useState(null);
  const [dataDoughnut, setDataDoughnut] = useState(null);
  const [dataInterval, setDataInterval] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const paramsBar = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        const responseBar = await HomeService.getBar(paramsBar);
        let errBar = StatusHandler(responseBar);
        if (!errBar.isFail) {
          setDataBar(responseBar.data.Value);
        }
        const paramsInterval = {
          KeyUser: read("userKey"),
          KeyGroup: read("groupKey"),
        };
        const responseInterval = await HomeService.intervalBar(paramsInterval);
        let errInterval = StatusHandler(responseInterval);
        if (!errInterval.isFail) {
          setDataInterval(responseInterval.data.Value)
        }
        const paramsLine = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        const responseLine = await HomeService.getLine(paramsLine);
        let errLine = StatusHandler(responseLine);
        if (!errLine.isFail) {
          setDataLine(responseLine.data.Value);
        }
        const paramsPie = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        const responsePie = await HomeService.getPie(paramsPie);
        let errPie = StatusHandler(responsePie);
        if (!errPie.isFail) {
          setDataPie(responsePie.data.Value);
        }
        const paramsDoughnut = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        const responseDoughnut = await HomeService.getDoughnut(paramsDoughnut);
        let errDoughnut = StatusHandler(responseDoughnut);
        if (!errDoughnut.isFail) {
          setDataDoughnut(responseDoughnut.data.Value);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
        { (externalData.number_of_projects !== 0 && externalData.number_of_customers !== 0) &&
          <div className="m-2 mt-3">
            <BackDropLoading loading={loading} />
            <Grid container spacing={3}>
              <Grid container spacing={3} className="mb-2">
                <Grid item xs={12} md={8}>
                  {
                    dataBar && dataInterval &&
                    <MuiPaper>
                      <BarChart data={dataBar} dataInterval={dataInterval}/>
                    </MuiPaper>
                  }
                </Grid>
                <Grid item xs={12} md={4}>
                  {
                    dataPie &&
                    <MuiPaper className="h-100">
                      <PieChart data={dataPie} />
                    </MuiPaper>
                  }
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  {
                    dataLine &&
                    <MuiPaper className="h-100">
                      <LineChart data={dataLine} />
                    </MuiPaper>
                  }
                </Grid>
                <Grid item xs={12} md={4}>
                  {
                    dataDoughnut &&
                    <MuiPaper className="h-100">
                      <DoughnutChart data={dataDoughnut}/>
                    </MuiPaper>
                  }
                </Grid>
              </Grid>
            </Grid>
          </div>
        }
    </>
  );
}